module.exports = __webpack_public_path__ + "img/5499aba68d6f404894330a8ec207fb4b.996dafe3.png";